/**
 * Shared prop mapping / feedback adapters so My VQQs + Details callers stay thin
 * for Sonar new-code coverage.
 */

export function toReopenConfirmModalProps(flow, vendorName) {
  return {
    open: Boolean(flow?.confirmOpen),
    onClose: flow?.closeConfirm,
    onConfirm: flow?.confirmReopen,
    loading: Boolean(flow?.isPending),
    vendorName,
  };
}

export function createDetailsReopenFeedbackHandlers({
  setNotificationStatus,
  setUpdateNotificationOpen,
  setMessage,
  refetch,
  activityRefetch,
}) {
  return {
    setLocalNotificationError: (isErr) =>
      setNotificationStatus?.(isErr ? "error" : "success"),
    setShowNotification: setUpdateNotificationOpen,
    setMessage,
    refetch: () => {
      refetch?.();
      activityRefetch?.();
    },
  };
}

export function resolveReopenVendorName(details) {
  return details?.vendor_name ?? details?.vendorName;
}
